import React from "react";
import { Link } from "react-router-dom";
import Compromiso from "../assets/icons/gambler.png";
import Profesionales from "../assets/icons/roulette.png";

const Feature = ({ icon, title, children }) => (
  <div style={{
    background: 'var(--sb-bg-card)',
    border: '1px solid var(--sb-border)',
    borderRadius: 'var(--sb-radius-md)',
    padding: '1.75rem',
    height: '100%',
    transition: 'border-color 0.2s ease',
  }}
    onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--sb-border-accent)'}
    onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--sb-border)'}
  >
    <div style={{ marginBottom: '1rem' }}>
      <img src={icon} width={40} alt="" style={{ opacity: 0.9 }} />
    </div>
    <h5 style={{ color: 'var(--sb-text-primary)', fontWeight: 700, marginBottom: '0.6rem', fontSize: '1rem' }}>{title}</h5>
    <p style={{ color: 'var(--sb-text-secondary)', fontSize: '0.875rem', lineHeight: 1.7, margin: 0 }}>{children}</p>
  </div>
);

const Section = ({ title, children }) => (
  <div style={{ marginBottom: '2.5rem' }}>
    <h3 style={{
      color: 'var(--sb-text-primary)',
      fontSize: '1.15rem',
      fontWeight: 700,
      marginBottom: '0.6rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    }}>
      <span style={{ width: 3, height: 18, background: 'var(--sb-accent)', borderRadius: 2, display: 'inline-block' }} />
      {title}
    </h3>
    <div style={{ color: 'var(--sb-text-secondary)', fontSize: '0.9rem', lineHeight: 1.75 }}>
      {children}
    </div>
  </div>
);

class Nosotros extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
  }

  render() {
    return (
      <main>

        {/* ── Hero ─────────────────────────────────────────── */}
        <section style={{
          padding: '5rem 0 3.5rem',
          background: 'radial-gradient(ellipse 80% 50% at 50% -10%, rgba(59,130,246,0.11) 0%, transparent 60%), var(--sb-bg-base)',
          textAlign: 'center',
        }}>
          <div className="container">
            <div className="sb-section-label" style={{ marginBottom: '0.75rem' }}>About us</div>
            <h1 style={{
              fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
              fontWeight: 800,
              color: 'var(--sb-text-primary)',
              letterSpacing: '-0.03em',
              marginBottom: '0.75rem',
            }}>
              Real-time roulette statistics
            </h1>
            <p style={{ color: 'var(--sb-text-secondary)', fontSize: '1rem', maxWidth: 480, margin: '0 auto 2rem' }}>
              StakeBits tracks live Evolution roulette tables so you always have the numbers, trends, and patterns you need.
            </p>
            <Link to="/tables" className="btn-sb-primary" style={{ fontSize: '0.9rem' }}>
              Explore tables →
            </Link>
          </div>
        </section>

        {/* ── Feature cards ─────────────────────────────────── */}
        <section style={{ padding: '3.5rem 0', background: 'var(--sb-bg-surface)' }}>
          <div className="container">
            <div className="row g-3">
              <div className="col-12 col-md-6">
                <Feature icon={Profesionales} title="Our data">
                  Statistics include a variety of data — frequency of numbers, colors, dozens, neighbors on the roulette wheel, sectors, and much more. The tracker interface ensures transparency and openness, allowing players to make more informed decisions.
                </Feature>
              </div>
              <div className="col-12 col-md-6">
                <Feature icon={Compromiso} title="Evolution Roulette">
                  We work with all live tables from Evolution, the world's leading live casino provider. Every spin is captured and processed in real time across all available roulette variants.
                </Feature>
              </div>

              {[
                {
                  emoji: '📊',
                  title: 'Spin History',
                  body: 'Full spin history with result, dealer, number type, and timestamp. Sort and filter across hundreds of past spins to spot patterns at a glance.',
                },
                {
                  emoji: '🌡️',
                  title: 'Temperature',
                  body: 'See which numbers are hot and cold based on recent activity. Hit frequency and percentages are updated after every spin.',
                },
                {
                  emoji: '🎡',
                  title: 'Tier Details',
                  body: 'The wheel is divided into four tiers — Orphans, Neighbours of Zero, Third of the Wheel, and Zero Game — each with live hit frequency.',
                },
                {
                  emoji: '⚡',
                  title: 'Real-time Updates',
                  body: 'All data is updated live as spins come in. No refresh needed — charts, tables, and badges reflect the latest state automatically.',
                },
              ].map(({ emoji, title, body }) => (
                <div key={title} className="col-12 col-md-6 col-lg-3">
                  <div style={{
                    background: 'var(--sb-bg-card)',
                    border: '1px solid var(--sb-border)',
                    borderRadius: 'var(--sb-radius-md)',
                    padding: '1.5rem',
                    height: '100%',
                  }}>
                    <div style={{ fontSize: '1.5rem', marginBottom: '0.75rem' }}>{emoji}</div>
                    <h5 style={{ color: 'var(--sb-text-primary)', fontWeight: 700, fontSize: '0.95rem', marginBottom: '0.5rem' }}>{title}</h5>
                    <p style={{ color: 'var(--sb-text-secondary)', fontSize: '0.83rem', lineHeight: 1.65, margin: 0 }}>{body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Detailed sections ─────────────────────────────── */}
        <section style={{ padding: '4rem 0' }}>
          <div className="container">
            <div className="row g-5">

              <div className="col-lg-7">
                <div className="sb-section-label" style={{ marginBottom: '1rem' }}>How it works</div>

                <Section title="About our Stats">
                  Looking to find the latest statistics and results from live Evolution roulette tables? You will be able to find all this and any information you might need right here — from spin history to number frequency and tier breakdowns.
                </Section>

                <Section title="Spin History">
                  This section is dedicated to the spin history of the game, giving you all relevant information such as the spin result, the dealer, and the number type. You can also sort by day/time the spin was finished and browse through hundreds of past spins.
                </Section>

                <Section title="Temperature">
                  The Temperature section gives you an overview of which numbers are hot and cold. You will be able to see the hit frequency of both hot and cold numbers based on the past hours and hundreds of spins. The hit percentage is shown under each number listed.
                </Section>

                <Section title="Tier Details">
                  <p style={{ marginBottom: '1rem' }}>
                    The roulette wheel is sectioned off into four tiers. Each section shows its hit frequency across the last 298 spins:
                  </p>
                  <ul style={{ paddingLeft: '1.25rem', display: 'flex', flexDirection: 'column', gap: '0.5rem', margin: 0 }}>
                    {[
                      { name: 'Orphans', desc: 'Covers 2 segments including numbers 17, 34, 6, 1, 20, 14, 31 and 9.' },
                      { name: 'Neighbours of Zero', desc: 'Two segments on either side of Zero including 22, 18, 29, 7, 28, 19, 4, 21, 2 and 25.' },
                      { name: 'Third of the Wheel', desc: 'A third of the wheel including 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16 and 33.' },
                      { name: 'Zero Game', desc: 'The smallest segment, numbers closest to zero: 12, 35, 3, 26, 0, 32 and 15.' },
                    ].map(({ name, desc }) => (
                      <li key={name} style={{ color: 'var(--sb-text-secondary)', fontSize: '0.875rem' }}>
                        <strong style={{ color: 'var(--sb-text-primary)' }}>{name}</strong> — {desc}
                      </li>
                    ))}
                  </ul>
                </Section>
              </div>

              {/* Sidebar */}
              <div className="col-lg-4 offset-lg-1">
                <div style={{
                  position: 'sticky',
                  top: '5rem',
                }}>
                  <div style={{
                    background: 'var(--sb-bg-card)',
                    border: '1px solid var(--sb-border)',
                    borderRadius: 'var(--sb-radius-lg)',
                    padding: '1.75rem',
                    marginBottom: '1rem',
                  }}>
                    <div style={{ fontSize: '1.25rem', marginBottom: '0.75rem' }}>📬</div>
                    <h5 style={{ color: 'var(--sb-text-primary)', fontWeight: 700, fontSize: '0.95rem', marginBottom: '0.5rem' }}>Get in touch</h5>
                    <p style={{ color: 'var(--sb-text-secondary)', fontSize: '0.85rem', marginBottom: '1rem' }}>
                      Questions, feedback, or support? Reach us anytime.
                    </p>
                    <a
                      href="mailto:info@stakebits.co"
                      style={{
                        display: 'block',
                        textAlign: 'center',
                        padding: '0.6rem 1rem',
                        background: 'var(--sb-bg-elevated)',
                        border: '1px solid var(--sb-border-strong)',
                        borderRadius: 'var(--sb-radius-sm)',
                        color: 'var(--sb-text-primary)',
                        fontSize: '0.875rem',
                        fontWeight: 500,
                        textDecoration: 'none',
                        transition: 'border-color 0.2s',
                      }}
                    >
                      info@stakebits.co
                    </a>
                  </div>

                  <div style={{
                    background: 'var(--sb-bg-card)',
                    border: '1px solid var(--sb-border)',
                    borderRadius: 'var(--sb-radius-lg)',
                    padding: '1.75rem',
                  }}>
                    <div style={{ fontSize: '1.25rem', marginBottom: '0.75rem' }}>🚀</div>
                    <h5 style={{ color: 'var(--sb-text-primary)', fontWeight: 700, fontSize: '0.95rem', marginBottom: '0.5rem' }}>Ready to start?</h5>
                    <p style={{ color: 'var(--sb-text-secondary)', fontSize: '0.85rem', marginBottom: '1rem' }}>
                      Access all tables and real-time data with a simple subscription.
                    </p>
                    <Link to="/pricing" className="btn-sb-primary" style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                      View pricing
                    </Link>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    );
  }
}

export default Nosotros;
